import t from "../../../node_modules/style-inject/dist/style-inject.es.js";
var a = ".fast-nav{margin-bottom:24px}.fast-nav :global .ant-breadcrumb{display:flex;align-items:center}@media (max-width:767px){.bread{margin-bottom:12px}}";
t(a);
export default a;